import { put, takeLatest } from "redux-saga/effects";
import { thamSoHeThongApi } from "../../../api/category/thamSoHeThongApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { eThamSoHeThongActionIds } from "../../action-types/category/IThamSoHeThongActions";

export function* thamSoHeThongSaga() {
    yield takeLatest(eThamSoHeThongActionIds.LOAD_START, loadWorker);
    yield takeLatest(eThamSoHeThongActionIds.UPDATES_START, UpdateThamSosWorker);
}

function* loadWorker() : any {
    const response: IBaseResponse = yield thamSoHeThongApi.SelectAll();
   
    if (response.is_success) {
      yield put(rootActions.category.thamSoHeThong.LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.category.thamSoHeThong.LOAD_ERROR(response.message || "Lỗi khi tải tham số hệ thống"));
    }
}

function* UpdateThamSosWorker(action: any): any {
    const thamSoHeThongs = action.payload;
    let countSuccess = 0;
    let countError = 0;

    if (!thamSoHeThongs || thamSoHeThongs.length === 0) {
        yield put(rootActions.category.thamSoHeThong.UPDATES_ERROR("Không có tham số nào được chọn để cập nhật."));
        return;
    }

    for (const thamSo of thamSoHeThongs) {
        const response: IBaseResponse = yield thamSoHeThongApi.UpdateThamSo(thamSo);
        if (response.is_success) {
            countSuccess++;
        } else {
            countError++;
        }
    }

    if (countSuccess > 0) {
        yield put(rootActions.category.thamSoHeThong.UPDATES_SUCCESS(`Cập nhật thành công cho ${countError} tham số.`));
    } else {
        yield put(rootActions.category.thamSoHeThong.UPDATES_ERROR(`Cập nhật thất bại cho ${countError} tham số.`));
    }
}